// extracted by mini-css-extract-plugin
module.exports = {"cardCreation_buttons":"App_cardCreation_buttons__x-kaA"};